import { useEffect, useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { RiSearchLine } from "react-icons/ri";
import { getParkingLocationsDropDownList } from "../../services/Networkcall";
import { errorAlert } from "../common/Alert";

export default function EntryFilters({ filters, setFilters }) {

  const [locationOptions, setLocationOptions] = useState([]);

  const fetchParkingLocationsDropDownList = async () => {
    try {
      const res = await getParkingLocationsDropDownList();
      if (res?.success) {
        const options = res?.data.map((item) => ({ name: item?.locationName, value: item?._id }));
        setLocationOptions(options);
      }
      else {
        errorAlert({ message: res?.message })
      }
    } catch (err) {
      errorAlert({ message: err?.response?.data?.message || err?.message || 'something went wrong' })
    }
  }

  useEffect(() => { fetchParkingLocationsDropDownList(); }, [])


  const handleChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleReset = () => {
    setFilters({
      search: "",
      startDate: "",
      activity: "",
      yard: "",
    });
  };

  return (
    <Row className="ee-filters g-2">

      {/* SEARCH */}
      <Col xl={3} md={12}>
        <div className="search">
          <RiSearchLine />
          <input
            placeholder="Search by driver, truck, plate, or gate code..."
            value={filters.search}
            onChange={(e) => handleChange("search", e.target.value)}
          />
        </div>
      </Col>

      {/* ACTIVITY */}
      <Col xl={2} md={4}>
        <Form.Select
          value={filters.activity}
          onChange={(e) =>
            handleChange("activity", e.target.value)
          }
        >
          <option value="">All Activity</option>
          <option value="ENTRY">Entry</option>
          <option value="EXIT">Exit</option>
        </Form.Select>
      </Col>

      {/* YARDS */}
      <Col xl={2} md={4}>
        <Form.Select
          value={filters.yard}
          onChange={(e) => handleChange("yard", e.target.value)}
        >
          <option value="">All Yards</option>
          {locationOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.name}
            </option>
          ))}
        </Form.Select>
      </Col>

      {/* DATE */}
      <Col xl={2} md={4}>
        <Form.Control
          type="date"
          value={filters.startDate || ""}
          onChange={(e) =>
            handleChange("startDate", e.target.value)
          }
        />
      </Col>

      {/* RESET */}
      <Col xl={1} md={4}>
        <Button
          variant="light"
          className="reset-btn p-2"
          onClick={handleReset}
        >
          Reset
        </Button>
      </Col>

    </Row>
  );
}